module.exports = __webpack_public_path__ + "img/frame-evening.43c109bd.png";